import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';

import { SystemAnnouncement } from './system-announcements.types';
import { SystemAnnouncementService } from './system-announcements.service';
import { AuthProviderService } from '../-services-/auth-framework/auth-provider.service';
import { eSupportRole } from '../-services-/auth-framework/api-constants/roles/role-instances';
import { decodeBase64 } from '../common/util/utilities';

@Component({
  selector: 'app-system-announcements',
  templateUrl: './system-announcements.component.html',
  styleUrl: './system-announcements.component.css'
})
export class SystemAnnouncementsComponent {
  isFetching = false;
  announcements: SystemAnnouncement[] = [];

  isAdd = true;
  showModal = false;
  selectedAnnouncement?: SystemAnnouncement;

  showDeleteConfirmation = false;
  deleteMsg = 'Are you sure you want to delete this announcement?';

  constructor(
    private authService: AuthProviderService,
    private dataService: SystemAnnouncementService,
    private readonly msgService: MessageService
  ) {}

  get hasWriteAccess() {
    return [eSupportRole].some((role) => this.authService.verifyUserRole(role));
  }

  ngOnInit(): void {
    this.fetchAnnouncements();
  }

  fetchAnnouncements() {
    this.isFetching = true;
    this.dataService.getAnnouncements().subscribe({
      next: (res: any) => {
        this.announcements = res;
        if (res.length) {
          this.dataService.dismissAnnouncement(res[0].id).subscribe();
        }
        this.isFetching = false;
      },
      error: (err) => {
        this.announcements = [];
        this.isFetching = false;
      }
    });
  }

  onPostAnnouncement = (details?: SystemAnnouncement) => {
    if (details) {
      this.isAdd = false;
      this.selectedAnnouncement = details;
    }
    this.showModal = true;
  };

  onDeleteAnnouncement = (details?: SystemAnnouncement) => {
    if (details) {
      this.selectedAnnouncement = details;
      this.showDeleteConfirmation = true;
    } else if (this.selectedAnnouncement) {
      this.isFetching = true;
      this.dataService.deleteAnnouncement(this.selectedAnnouncement?.id).subscribe({
        next: (res: any) => {
          this.isFetching = false;
          this.sendMsg('success', `Announcement deleted successfully`);
          this.onClose(true);
        },
        error: (err) => {
          this.isFetching = false;
          this.sendMsg('error', err?.error?.message);
        }
      });
    }
  };

  onClose = (forceRefresh = false) => {
    this.isAdd = true;
    this.selectedAnnouncement = undefined;
    this.showModal = false;
    this.showDeleteConfirmation = false;
    this.isFetching = false;

    if (forceRefresh) {
      this.fetchAnnouncements();
    }
  };

  sendMsg = (type: string, msg: string, detail = '') => {
    const errorTitle = msg || 'Something went wrong';
    this.msgService.add({ severity: type, summary: errorTitle, detail, closable: true });
  };

  decodeContent(data: string) {
    return decodeBase64(data);
  }
}
